import { useSendContactFormMutation } from '@apis/originalTokkoApi/contact'
import { makeJsonServices } from '@helpers/helper.contact'
import { ElementHTML } from '@helpers/helper.rendering'
import useQuerySummary from '@hooks/useQuerySummary'
import React, { useEffect, useRef, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import ReCAPTCHA from 'react-google-recaptcha'
import toast from 'react-hot-toast'
import { RealEstateDataPageComponentData } from 'types'
import { useCreateFormMutation as useSendContactFormMutationMediacore } from '@apis/mediacore/contact'

interface DataServices {
  name: string
  lastname?: string
  email: string
  phone?: string
  operation: string
  type: string
  location: string
  sup_cub: string
  sup_tot: string
  rooms: string
  garage: string
  age: string
  amenities: string[]
}

const BD_Form_Tasaciones_1 = ({
  global_data,
  title,
  subtitle,
  button,
  is_short,
  is_wide,
  titleElement,
  titleSecondary,
  titlesForm,
  paragraphElement,
  placeholders,
  backgroundSecondary,
}: RealEstateDataPageComponentData) => {
  const type = useRef<any>()
  const operation = useRef<any>()
  const [datos, setDatos] = useState<DataServices>({
    name: '',
    lastname: '',
    email: '',
    phone: '',
    operation: '',
    type: '',
    location: '',
    sup_cub: '',
    sup_tot: '',
    rooms: '',
    garage: '',
    age: '',
    amenities: [],
  })
  const [disabled, setDisabled] = useState(true)
  const captcha = global_data.pageConfig.keys.captcha
  const API_KEY = global_data.pageConfig.keys.tokko
  const { allSummaryData } = useQuerySummary({ API_KEY })
  const [sendContactForm] = useSendContactFormMutation()
  const [sendContactFormMediacore] = useSendContactFormMutationMediacore()

  const [error, setIsError] = useState(false)

  const [token, setValueToken] = useState('')

  const handleInputChange = (event: any) => {
    setIsError(false)
    if (event.target.name == 'amenities') {
      if (datos.amenities.find((element) => element === event.target.value)) {
        const newAmenities = datos.amenities.filter((element) => element !== event.target.value)
        setDatos({
          ...datos,
          [event.target.name]: newAmenities,
        })
        return null
      }
      setDatos({
        ...datos,
        amenities: [...datos.amenities, event.target.value],
      })
      return null
    }
    setDatos({
      ...datos,
      [event.target.name]: event.target.value,
    })
  }

  const sendForm = (event: any) => {
    // const body = makeJsonServices({ ...datos, tags: ['Sitio web', 'Tasación', global_data.name] })
    sendContactFormMediacore({
      data: { ...datos, tags: ['Sitio web', 'Tasación', global_data.name], token: token },
      type: 'services',
      site: global_data.id,
    })
    if (API_KEY) {
      // sendContactForm({ API_KEY: API_KEY, body: body })
    }
    event.preventDefault()
    ;(document?.getElementById('formServices') as HTMLFormElement).reset()
    return toast.success('¡Mensaje enviado correctamente!')
  }

  function onChange(value: any) {
    setValueToken(value)
  }
  useEffect(() => {
    if (!captcha) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [])

  return (
    <section
      className="servicesForm a"
      style={{ backgroundColor: backgroundSecondary ? '#fff' : '#f9f9f9' }}
    >
      <Container fluid>
        <Row className="justify-content-center p-y-config">
          <Col
            lg={12}
            className="text-center"
          >
            {title && (
              <ElementHTML
                children={title || 'Servicios'}
                elementType={titleElement || 'h2'}
                className={'mb-lg-4 section-name ' + (titleSecondary ? 'primary-color' : '')}
              />
            )}
            {subtitle && (
              <ElementHTML
                children={subtitle || ''}
                elementType={paragraphElement || 'p'}
              />
            )}
          </Col>
          <Col lg={{ span: is_wide ? 8 : 6 }}>
            <form
              onSubmit={sendForm}
              id="formServices"
              className="row content-form ajax-form a"
            >
              <div className="col-lg-12">
                <div className="row">
                  <label className="text-uppercase">{'DATOS DE CONTACTO'}</label>
                  <div
                    className={'camp mb-lg-4 py-lg-1 mb-4 ' + (is_short ? 'col-lg-6' : 'col-lg-12')}
                  >
                    <input
                      onChange={handleInputChange}
                      onClick={() => setIsError(false)}
                      type="text"
                      required
                      name="name"
                      placeholder={
                        error && datos.name === ''
                          ? 'Completar con tu ' + (is_short ? 'nombre' : 'nombre y apellido')
                          : is_short
                          ? 'Nombre *'
                          : 'Nombre y Apellido *'
                      }
                      className={error && datos.name === '' ? 'border-red' : ''}
                    />
                  </div>
                  {is_short && (
                    <div className="col-lg-6 camp mb-lg-4 py-lg-1 mb-4">
                      <input
                        onChange={handleInputChange}
                        onClick={() => setIsError(false)}
                        type="text"
                        required
                        name="lastname"
                        placeholder={
                          error && datos.lastname === ''
                            ? 'Completar con tu apellido'
                            : 'Apellido *'
                        }
                        className={error && datos.lastname === '' ? 'border-red' : ''}
                      />
                    </div>
                  )}
                  <div
                    className={
                      'camp ' + (is_short ? 'col-lg-6 mb-lg-4 mb-4 ' : 'col-lg-12 separator-block')
                    }
                  >
                    <input
                      onChange={handleInputChange}
                      onClick={() => setIsError(false)}
                      type="text"
                      required
                      name="email"
                      placeholder={
                        error && datos.email === '' ? 'Completar con tu email' : 'E-Mail *'
                      }
                      className={error && datos.email === '' ? 'border-red' : ''}
                    />
                  </div>
                  {is_short && (
                    <div className="col-lg-6 separator-block camp mb-lg-4 mb-4">
                      <input
                        onChange={handleInputChange}
                        type="text"
                        name="phone"
                        placeholder={'Teléfono'}
                      />
                    </div>
                  )}
                  <label className="text-uppercase">DATOS DE PROPIEDAD</label>
                  <div className="col-lg-6 pr-lg-3 pl-lg-2 mb-4 mb-lg-4 position-relative">
                    <select
                      required
                      ref={operation}
                      onChange={handleInputChange}
                      name="operation"
                    >
                      <option value="">Operación</option>
                      {allSummaryData &&
                      allSummaryData.objects.operation_types.find(
                        (element: { operation_type: number }) => element.operation_type === 1,
                      ) ? (
                        <option value="Venta">Venta</option>
                      ) : (
                        ''
                      )}
                      {allSummaryData &&
                      allSummaryData.objects.operation_types.find(
                        (element: { operation_type: number }) => element.operation_type === 2,
                      ) ? (
                        <option value="Alquiler">Alquiler</option>
                      ) : (
                        ''
                      )}
                      {allSummaryData &&
                      allSummaryData.objects.operation_types.find(
                        (element: { operation_type: number }) => element.operation_type === 3,
                      ) ? (
                        <option value="Alquiler Temporario">Alquiler Temporario</option>
                      ) : (
                        ''
                      )}
                    </select>
                    <i></i>
                  </div>
                  <div className="col-lg-6 pr-lg-3 mb-4 mb-lg-4 position-relative">
                    <select
                      ref={type}
                      onChange={handleInputChange}
                      name="type"
                    >
                      <option value="">Tipo de propiedad</option>
                      {allSummaryData
                        ? allSummaryData.objects.property_types.map(
                            (
                              item: {
                                type:
                                  | string
                                  | number
                                  | boolean
                                  | React.ReactElement<
                                      any,
                                      string | React.JSXElementConstructor<any>
                                    >
                                  | Iterable<React.ReactNode>
                                  | null
                                  | undefined
                              },
                              index: any,
                            ) => (
                              <option
                                key={index}
                                value={item.type?.toString()}
                              >
                                {item.type}
                              </option>
                            ),
                          )
                        : ''}
                    </select>
                    <i></i>
                  </div>
                  <div className="col-lg-12 pr-lg-3 pr-lg-2 separator-block">
                    <input
                      onChange={handleInputChange}
                      onClick={() => setIsError(false)}
                      type="text"
                      required
                      placeholder={
                        error && datos.location === ''
                          ? 'Completar con la ubicación de la propiedad'
                          : 'Ubicación *'
                      }
                      className={error && datos.location === '' ? 'border-red' : ''}
                      name="location"
                      id="location"
                    />
                  </div>
                  <div className="col-12 pr-3 separator-block camp">
                    <div className="row">
                      <div className="col-lg-6">
                        <label className="text-uppercase">Ambientes</label>
                        <div className="ticks d-flex justify-content-between align-items-center">
                          <span className="option numbers">
                            <input
                              onChange={handleInputChange}
                              type="radio"
                              id="amb-1"
                              name="rooms"
                              value="1"
                            />
                            <label
                              htmlFor="amb-1"
                              className="mb-0"
                            >
                              <span className="square customBorders">1</span>
                            </label>
                          </span>
                          <span className="option numbers">
                            <input
                              onChange={handleInputChange}
                              type="radio"
                              id="amb-2"
                              name="rooms"
                              value="2"
                            />
                            <label
                              htmlFor="amb-2"
                              className="mb-0"
                            >
                              <span className="square customBorders">2</span>
                            </label>
                          </span>
                          <span className="option numbers">
                            <input
                              onChange={handleInputChange}
                              type="radio"
                              id="amb-3"
                              name="rooms"
                              value="3"
                            />
                            <label
                              htmlFor="amb-3"
                              className="mb-0"
                            >
                              <span className="square customBorders">3</span>
                            </label>
                          </span>
                          <span className="option numbers">
                            <input
                              onChange={handleInputChange}
                              type="radio"
                              id="amb-4"
                              name="rooms"
                              value="4"
                            />
                            <label
                              htmlFor="amb-4"
                              className="mb-0"
                            >
                              <span className="square customBorders">4</span>
                            </label>
                          </span>
                          <span className="option numbers">
                            <input
                              onChange={handleInputChange}
                              type="radio"
                              id="amb-5"
                              name="rooms"
                              value="5"
                            />
                            <label
                              htmlFor="amb-5"
                              className="mb-0"
                            >
                              <span className="square customBorders">5</span>
                            </label>
                          </span>
                          <span className="option numbers">
                            <input
                              onChange={handleInputChange}
                              type="radio"
                              id="amb-6"
                              name="rooms"
                              value="6"
                            />
                            <label
                              htmlFor="amb-6"
                              className="mb-0"
                            >
                              <span className="square customBorders">+</span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 pr-3 separator-block camp">
                    <input
                      onChange={handleInputChange}
                      type="text"
                      name="sup_cub"
                      placeholder="Superficie Cubierta (m2)"
                    />
                  </div>
                  <div className="col-6 pl-3 separator-block camp">
                    <input
                      onChange={handleInputChange}
                      type="text"
                      name="sup_tot"
                      placeholder="Superficie Total (m2)"
                    />
                  </div>
                  <div className="col-lg-6 separator-block camp">
                    <label className="text-uppercase">Antigüedad</label>
                    <div className="ticks row d-flex justify-content-between align-items-center">
                      <div className="col-6">
                        <span className="option option-check">
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            id="age-1"
                            name="age"
                            value="A estrenar"
                          />
                          <label
                            htmlFor="age-1"
                            className="mb-0 me-0"
                          >
                            <span className=""></span>A estrenar
                          </label>
                        </span>
                      </div>
                      <div className="col-6">
                        <span className="option option-check">
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            id="age-2"
                            name="age"
                            value="Hasta 10 años"
                          />
                          <label
                            htmlFor="age-2"
                            className="mb-0 me-0"
                          >
                            <span className=""></span>Hasta 10 años
                          </label>
                        </span>
                      </div>
                      <div className="col-6 mt-3">
                        <span className="option option-check">
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            id="age-3"
                            name="age"
                            value="10 - 50 años"
                          />
                          <label
                            htmlFor="age-3"
                            className="mb-0 me-0"
                          >
                            <span className=""></span>10 - 50 años
                          </label>
                        </span>
                      </div>
                      <div className="col-6 mt-3">
                        <span className="option option-check">
                          <input
                            onChange={handleInputChange}
                            type="radio"
                            id="age-4"
                            name="age"
                            value="+50 años"
                          />
                          <label
                            htmlFor="age-4"
                            className="mb-0 me-0"
                          >
                            <span className=""></span>+50 años
                          </label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 camp separator-block d-none d-lg-block">
                    <label>Garage</label>
                    <div className="ticks d-flex justify-content-start align-items-center">
                      <span className="option option-check me-5">
                        <input
                          onChange={handleInputChange}
                          type="radio"
                          id="garage-1"
                          name="garage"
                          value="Sí"
                        />
                        <label
                          htmlFor="garage-1"
                          className="mb-0"
                        >
                          <span className=""></span>Sí
                        </label>
                      </span>
                      <span className="option option-check me-5">
                        <input
                          onChange={handleInputChange}
                          type="radio"
                          id="garage-2"
                          name="garage"
                          value="No"
                        />
                        <label
                          htmlFor="garage-2"
                          className="mb-0"
                        >
                          <span className=""></span>No
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-12 separator-block mt-4 mt-lg-0">
                    <label className="mb-4 text-uppercase">Amenities</label>
                    <div className="mt-2 ticks row align-items-start justify-content-between justify-content-lg-start">
                      <div className="col-lg-3 col-6">
                        <span className="option option-check">
                          <input
                            onChange={handleInputChange}
                            type="checkbox"
                            id="SUM"
                            name="amenities"
                            value="SUM"
                          />
                          <label
                            className="mb-3"
                            htmlFor="SUM"
                          >
                            <span className="square"></span>SUM
                          </label>
                        </span>
                      </div>
                      <div className="col-lg-3 col-6">
                        <span className="option option-check">
                          <input
                            onChange={handleInputChange}
                            type="checkbox"
                            id="Laundry"
                            name="amenities"
                            value="Laundry"
                          />
                          <label
                            className="mb-3"
                            htmlFor="Laundry"
                          >
                            <span className="square"></span>Laundry
                          </label>
                        </span>
                      </div>
                      <div className="col-lg-3 col-6">
                        <span className="option option-check">
                          <input
                            onChange={handleInputChange}
                            type="checkbox"
                            id="Pileta"
                            name="amenities"
                            value="Pileta"
                          />
                          <label
                            className="mb-3"
                            htmlFor="Pileta"
                          >
                            <span className="square"></span>Pileta
                          </label>
                        </span>
                      </div>
                      <div className="col-lg-3 col-6">
                        <span className="option option-check">
                          <input
                            onChange={handleInputChange}
                            type="checkbox"
                            id="Gym"
                            name="amenities"
                            value="Gym"
                          />
                          <label
                            className="mb-3"
                            htmlFor="Gym"
                          >
                            <span className="square"></span>Gym
                          </label>
                        </span>
                      </div>
                      <div className="col-lg-3 col-6">
                        <span className="option option-check">
                          <input
                            onChange={handleInputChange}
                            type="checkbox"
                            id="Parrilla"
                            name="amenities"
                            value="Parrilla"
                          />
                          <label
                            className="mb-3"
                            htmlFor="Parrilla"
                          >
                            <span className="square"></span>Parrilla
                          </label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 camp">
                    <div
                      className={
                        'd-lg-flex w-100 border-top-separator ' +
                        (captcha && 'justify-content-lg-between align-items-start')
                      }
                    >
                      <div className={'d-lg-none d-block text-end mb-3 mt-lg-0 '}>
                        *Campos obligatorios
                      </div>
                      {captcha ? (
                        <ReCAPTCHA
                          sitekey={captcha ? captcha.toString() : '0'}
                          onChange={(value) => {
                            setDisabled(false)
                            onChange(value)
                          }}
                        />
                      ) : (
                        ''
                      )}
                      <div className={'d-none d-lg-block text-end mt-lg-0'}>
                        *Campos obligatorios
                      </div>
                    </div>
                    <input
                      type="submit"
                      disabled={disabled}
                      value={button?.value || 'ENVIAR'}
                      onClick={() => setIsError(true)}
                      className="btn btn-primary submit mt-4 d-block mx-auto mx-lg-0"
                      id="submit-info"
                    />
                  </div>
                </div>
              </div>
            </form>
          </Col>
        </Row>
      </Container>

      <div id="alert-message"></div>
    </section>
  )
}

export default BD_Form_Tasaciones_1
